<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="viewdetail">
              <i class="fa fa-eye"></i> Detail
            </b-dropdown-item>
            <b-dropdown-item @click="viewKronologis">
              <i class="fa fa-eye"></i> Show Kronologis
            </b-dropdown-item>
            <b-dropdown-item @click="printpdf">
              <i class="fa fa-print"></i> Print
            </b-dropdown-item>
            <!-- <b-dropdown-item @click="arusdokumenReceipt">
              <i class="fa fa-exchange"></i> Penerimaan Dokumen
            </b-dropdown-item>
            <b-dropdown-item @click="arusdokumenSubmit">
              <i class="fa fa-exchange"></i> Penyerahan Dokumen
            </b-dropdown-item> -->
          </b-dropdown>
          <button class="btn btn-primary mr-1" @click="showFilter = !showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Jaminan</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.no_jaminan" placeholder="No. Jaminan"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">Pemilik Jaminan</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.pemilikjaminan" placeholder="Pemilik Jaminan"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Sertifikat</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.sertifikatno" placeholder="No. Sertifikat"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">Kota</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.kota" placeholder="Kota Jaminan"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">Release Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nilai Jaminan</label>
                </b-input-group-prepend>
                <my-number v-model="tblData.nilai1" class="text-right"></my-number>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <my-number v-model="tblData.nilai2" class="text-right"></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tipe Jaminan</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.tipejaminan" :plain="true" :options="tpJaminan"></b-form-select>
                <b-input-group-prepend>
                  <span class="ml-2 pt-2">Project&nbsp;</span>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>

          <div class="text-right mb-2 mt-1">
            <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
          </div>

        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size: smaller" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :busy="isBusy" @row-clicked="rowClicked" show-empty>
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

        <template v-slot:cell(nilaijaminan)="data">{{
          data.item.nilaijaminan | numFormat('0,0.00')
        }}</template>
        <!-- <template v-slot:cell(alamat)="data">
          {{ data.item.alamat || "-" }}
          <br />
          Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
            data.item.kecamatan
          }}
          <br />
          Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
          <br />
          Kode Pos : {{ data.item.kodepos }}
        </template> -->

        <template v-slot:cell(detail)="data">
          <span v-if="data.item.tipejaminan == 'Kendaraan'">
            <b-row>
              <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
              <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
              <b-col md="6">- Tanggal STNK :
                {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col>
            </b-row>
          </span>
          <span v-else>
            <b-row>
              <b-col md="6">
                - Luas Tanah : {{ data.item.luastanah }} m
                <sup>2</sup>
              </b-col>
              <b-col md="6">
                - Luas Bangunan : {{ data.item.luasbangunan }} m
                <sup>2</sup>
              </b-col>
            </b-row>
            - Status Sertifikat : {{ data.item.sertifikatstatus }}
            <span v-if="data.item.sertifikatstatus === 'lainnya'">- {{ data.item.otherstatussertifikat }}</span>
            <b-row>
              <b-col md="6">- No Sertifikat : {{ data.item.sertifikatno }}</b-col>
              <b-col md="6">- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
              <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status Asuransi : {{ data.item.statusasuransi }}</b-col>
              <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
            </b-row>
          </span>
        </template>

        <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD/MM/YY")
        }}</template>

        <template v-slot:cell(released)="data">{{
          data.item.released | moment("DD/MM/YY")
        }}</template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>

        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>

        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
          tblData.total
        }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width: 80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal id="modal-prevent-closing" ref="modalKoronologis" title="Submit Kronologis" v-model="showModalKronologis"
      @ok="handleSubmitKronologis">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Kronologis" label-for="name-input">
          <b-form-textarea id="name-input" v-model="model.kronologis_note" required></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import moment from "moment";
import dropdown from "../../data/dropdown";
import project from "../../apis/project";
import toastr from "mini-toastr";
import agunan from "../../apis/agunankredit";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { myNumber, Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      showReport: false,
      reportUrl: null,
      isLoading: false,
      model: {},
      showModalKronologis: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        kota: null,
        nilai1: 0,
        nilai2: 0,
        no_jaminan: null,
        sertifikatno: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode || "",
        pjxkey: ''
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      tpJaminan: [
        { value: "", text: "--- ALL ---" },
        { text: "FA", value: "FA" },
        { text: "Kendaraan", value: "Kendaraan" },
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
    };
  },
  computed: {
    tblFields() {
      const fields = [
        { key: "index", label: "#" },
        {
          key: "no_jaminan",
          label: "No. Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "namajaminan",
          label: "Nama Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "tipejaminan",
          label: "Tipe Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "sertifikatno",
          label: "No. Sertifikat",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "kota",
          label: "Kota",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "kodepos",
          label: "Kode POS",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "released",
          label: "Release Date",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "kronologis_note",
          label: "Note",
          thClass: "text-center",
          thStyle: "width:2000px",
          tdClass: "text-left",
          sortable: true,
        },
        // {
        //   key: "no_kontrak",
        //   label: "No Kontrak",
        //   thClass: "text-center",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "tgl_kontrak",
        //   label: "Tgl. Kontrak",
        //   thClass: "text-center",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "tenor",
        //   label: "Tenor (Bln)",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:200px",
        //   sortable: true,
        // },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    user() {
      return this.$store.state.user;
    }
  },
  async created() {
    const this_ = this;
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }]);

    this.tblData.pjxkey = this.tblData.pjxkey || (this.sourceproject.length > 0 ? this.sourceproject[0].value : '');
  },
  methods: {
    viewdetail() {
      if (this.model.jaminankey) {
        router.push({
          name: "loan.agunandetail",
          params: { jaminankey: this.model.jaminankey },
        });
      } else {
        toastr.warn("Please select a row that want to be view!");
      }
    },
    arusdokumenReceipt() {
      if (this.model.jaminankey) {
        router.push({
          name: "loan.agunanarusdokumen",
          params: { jaminankey: this.model.jaminankey, tipetrx: 'receipt' },
        });
      } else {
        toastr.warn("Please select a row that want to be view!");
      }
    },
    arusdokumenSubmit() {
      if (this.model.jaminankey) {
        router.push({
          name: "loan.agunanarusdokumen",
          params: { jaminankey: this.model.jaminankey, tipetrx: 'submit' },
        });
      } else {
        toastr.warn("Please select a row that want to be view!");
      }
    },
    viewKronologis() {
      try {
        if (this.model.jaminankey) this.showModalKronologis = true;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async handleSubmitKronologis() {
      try {
        this.isLoading = true;

        if (this.model.jaminankey) {
          await crud.update({
            tablename: "fin-jaminan-crud",
            key: this.model.jaminankey,
            data: {
              kronologis_note: this.model.kronologis_note,
              modifiedby: this.user.username,
              modified: new Date()
            },
          });

          toastr.success("Data update successfully.", "SUCCESS");

        }
        this.refresh();
        this.isLoading = false;

      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        if (this.$route.params.keys) {
          this.tblData.jaminankeys = this.$route.params.keys;
        }
        const list = await agunan.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.pemilikjaminan = null;
      this.tblData.kota = null;
      this.tblData.nilai1 = 0;
      this.tblData.nilai2 = 0;
      this.tblData.no_jaminan = null;
      this.tblData.sertifikatno = null;
      this.tblData.tipejaminan = "";
      this.tblData.statusasuransi = "";
      this.refresh();
    },
    async exportxls() {
      try {
        await agunan.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async printpdf() {
      try {
        console.log('this', this.model);
        if (!this.model.jaminankey) {
          toastr.warn("Please select a row that want to be printed!");
          return;
        }
        this.isLoading = true;
        this.reportUrl = await agunan.printpdf(this.model);
        this.showReport = true;
        this.isLoading = false;
      } catch (error) {
        this.showReport = false;
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>

<style></style>